export const enum ELSKeys {
  token = 'TOKEN',
  userID = 'userID',
}

export enum ERoutes {
  singIn = '/singin',
  singUp = '/signup',
  main = '/main',
  welcome = '/welcome',
  profile = '/profile',
  boards = '/boards',
}
